import MarkerClustererPlus from 'marker-clusterer-plus'

const styles = {
  url: '/static/images/map/cluster-marker.svg',
  width: 30,
  height: 30,
  anchor: [15, 0],
  textColor: '#fff',
  textSize: 12,
  fontFamily: 'Gilroy'
}

export default {
  inject: ['$map'],
  data: () => ({
    cluster: null
  }),
  provide () {
    const provide = {}

    Object.defineProperty(provide, '$cluster', {
      enumerable: true,
      get: () => this.cluster
    })

    return provide
  },
  created () {
    this.cluster = new MarkerClustererPlus(this.$map, [], {
      gridSize: 55,
      maxZoom: 13,
      styles: [styles]
    })
  },
  render (h) {
    return this.cluster ? h('div', {class: ['cluster']}, this.$slots.default) : null
  }
}



// WEBPACK FOOTER //
// ./src/components/map/cluster.js